
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { StrategyWithDetails } from "@/types/strategy-types";
import { AccountPerformanceData } from "../marketplace/types/strategy-card-types";
import StrategyDetailContent from "./StrategyDetailContent";
import { useModalStack } from "@/hooks/useModalStack";

interface StrategyDetailDialogProps {
  isOpen: boolean;
  onClose: () => void;
  strategy: StrategyWithDetails | undefined;
  performanceData?: AccountPerformanceData;
}

const StrategyDetailDialog = ({ isOpen, onClose, strategy, performanceData }: StrategyDetailDialogProps) => {
  if (!strategy) return null;
  
  const dialogDescriptionId = "strategy-detail-description";
  
  // Use our modal stack hook to manage nested dialogs
  const { handleOpenChange } = useModalStack(isOpen, onClose);

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent 
        className="sm:max-w-[700px] p-0 overflow-hidden max-h-[90vh] flex flex-col"
        aria-describedby={dialogDescriptionId}
      >
        <DialogHeader className="p-6 bg-gray-50 border-b flex-shrink-0">
          <DialogTitle>
            {strategy.name || strategy.strategy_name} Details
          </DialogTitle>
          <DialogDescription id={dialogDescriptionId}>
            Details and performance metrics for {strategy.name || strategy.strategy_name}
          </DialogDescription>
        </DialogHeader>
        
        <div className="overflow-y-auto flex-1">
          <StrategyDetailContent 
            strategy={strategy} 
            performanceData={performanceData} 
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StrategyDetailDialog;
